<script>
import numberMixin from "@/mixins/numberMixin";

export default {
  mixins: [numberMixin],
  props: {
    districts: {
      type: Array,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    toggleFromList(district) {
      this.$emit("toggleFromList", district);
    },
    onList(id) {
      return this.list.find(item => item.id === id) ? true : false;
    }
  }
};
</script>

<template>
  <div class="table">
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Bairro</th>
          <th>Nota Mínima</th>
          <th>Valor Hora</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="district in districts" :key="district.id">
          <td class="icon" @click="toggleFromList(district)">
            <img v-if="onList(district.id)" :src="'/static/icon_check_circle.svg'">
            <img v-else :src="'/static/icon_times_circle.svg'">
          </td>
          <td>{{district.display_name}}</td>
          <td>{{district.rating.rating_min | intToDecimal}}</td>
          <td>{{district.pricing.price_per_hour | intToCurrency}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.icon {
  width: 15px;
  cursor: pointer;
}

.icon img {
  width: 15px;
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Coupons/AddDistricts/Districts.vue